module.exports = __webpack_public_path__ + "img/bored.be5030ca.webp";